import React from 'react';

const Toggle = ({ active, variant, onClick = () => {} }) => {
  return (
    <div className={`toggle ${active ? 'active' : ''} ${variant || ''}`} onClick={onClick}>
      <div />
    </div>
  );
};
export { Toggle };
